import React, { useEffect } from "react";
import "./style.scss";
import GoBack from "../../../assets/GoBackApp.svg";
import { useNavigate } from "react-router-dom";
import { PATH_LIST } from "shared/lib/react-router";
import { useTranslation } from "react-i18next";
import { useStore } from "zustand";
import { accountStore } from "entities/account";
import Loading from "widgets/loading";
import HistoryIcon from "../../../assets/HistoryClock.svg";
import RepoTransactionField from "../components/repo-transaction-field";

export const RepoTransaction: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("app");
  const {
    isLoading,
    depositPayments,
    depositPaymentsCount,
    getDepositPayments,
  } = useStore(accountStore);

  useEffect(() => {
    getDepositPayments();
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="repo-transaction">
      <div className="repo-transaction-header">
        <img
          className="go-back-repo-transaction"
          onClick={() => navigate(PATH_LIST.account)}
          src={GoBack}
          alt="Go Back"
        />
        <p>{t("longTermFundsPlacement")}</p>
        {depositPayments.filter((item: any) => item.paid).length > 0 && (
          <img
            className="repo-transaction-history"
            onClick={() => {
              navigate(PATH_LIST.repoTransactionHistory);
            }}
            src={HistoryIcon}
            alt="history"
          />
        )}
      </div>

      <div className="repo-transaction-main">
        {depositPaymentsCount > 0 ? (
          depositPayments
            .filter((item: any) => !item.paid)
            .map((item: any, index: number) => (
              <RepoTransactionField
                key={index}
                type="deposit-payment"
                data={item}
              />
            ))
        ) : (
          <p style={{ marginTop: "10%" }}>
            {t("noActiveLongTermFundsPlacement")}
          </p>
        )}
      </div>
    </div>
  );
};
